
import { useLocation, useNavigate } from "react-router-dom";
import { AccomodationContext } from "@utils/GlobalContext.js";
import { useContext } from "react";

export default function LogoComponent(props: {absolute: boolean}){ 
    const location = useLocation()
    const navigate = useNavigate();
    
    const { accomodationAndChildren } = useContext(AccomodationContext)
    if (accomodationAndChildren === undefined){
        return null
    }
    const { accomodation } = accomodationAndChildren
    return (
        <img 
            src={`data:image/png;base64,${accomodation?.accomodation?.logo ?? accomodation?.accomodation?.logo}`}
            alt="logo" 
            className={`logo-style ${props.absolute ? 'position-absolute' : ''}`} 
            onClick={()=>{navigate(`/${location.pathname.split("/")[1]}`)}}
        />
    );
}